import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_TRANSFERED_KEYWORDS_MUTATION } from '../graphql/mutations'
import { transformToUpdateTransferedKeywordsArgs } from '../graphql/transformers'
import { UPDATE_TRANSFERED_KEYWORDS } from '../redux/action-types'

const useUpdateTransferedKeywordsMutation = () => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.ingredients.ingredient?.keywords?.transfer || {},
  )

  const mutate = useCallback(
    (id, idToTransferTo, data) =>
      apolloService.mutate(
        UPDATE_TRANSFERED_KEYWORDS_MUTATION,
        {
          id,
          idToTransferTo,
          data: transformToUpdateTransferedKeywordsArgs(idToTransferTo, data),
        },
        dispatch,
        UPDATE_TRANSFERED_KEYWORDS,
      ),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateTransferedKeywordsMutation
